import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../../services/util/error.service'
import { parseToMysqlFormat } from '../../../../../services/util/date.service'
import {
  getEmpresas,
  getUsuarioInfo,
} from '../../../../../services/localstorage/localstorage.service'
import { getProdutos } from '../../../../../services/api/https/registration/produto.http'

function getCurrentTimeString() {
  const now = new Date()
  return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`
}

export const MENU_ITEMS = ['1. Editar', '2. Produtos']

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  PRODUTOS: 'Carregando Produtos',
  POSICOES: 'Carregando posições do estoque',
  POSICOES_SAIDA: 'Carregando posições do estoque que contem o produto',
  EXPEDIR: 'Expedindo items selecionados',
  MOVING: 'Concluindo operação',
}

const INITIAL_STATE = {
  showDialogExpedir: false,
  showModalRelatorio: false,
  selectedOperacao: null,
  selectedEstoque: null,
  operacoes: [],
  empresas: getEmpresas(),
  movimentacoes: [],
  modal: {
    show: false,
    data: null,
  },
  dataMovimentacao: new Date(),
  horaMovimentacao: '',
  posicoes: [],
  posicoesSaida: [],
  estoques: [],
  produtos: [],
  originalPosicoes: [],
  selectedEmpresa: {},
  selectedProduto: null,
  selectedProdutoSaida: null,
  selectedPosicoes: [],
  globalFilter: '',
  globalFilterPosicao: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  justificativa: '',
}

export default function useMovimentacaoEstoqueAvulso() {
  const [state, setState] = useState(() => ({ ...INITIAL_STATE, horaMovimentacao: getCurrentTimeString() }))

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
          pathToRedirect: null,
        }))
      },

      getPosicoesEstoque(selectedTp, estoqueId) {
        EstoqueHttp.getPosicoesEstoques(selectedTp, estoqueId)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              posicoes: res.map(r => ({ ...r, produtos: [], caixas_novas: 0, alocated: false })),
              originalPosicoes: res.map(r => ({
                ...r,
                produtos: [],
                caixas_novas: 0,
                alocated: false,
              })),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getPosicoesWhereProdutoIn(selectedTp, selectedProduto) {
        EstoqueHttp.getPosicoesWhereProdutoIn(selectedTp, selectedProduto.id)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              posicoesSaida: res.map(r => ({ ...r, qte_remover: 0 })),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getProdutosFromCompany(selectedEmpresa) {
        getProdutos(selectedEmpresa.id)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              produtos: res.produtos.map(p => ({
                ...p,
                alocated: false,
                validade: '',
                lote: '',
                qte_alocar: p.qte_total,
                movimentacoes: 0,
              })),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getProdutos(pickingId) {
        EstoqueHttp.getProdutosByPickingId(pickingId)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              produtos: res.map(p => ({
                ...p,
                alocated: false,
                validade: '__/__/____',
                lote: '',
                qte_alocar: p.qte_total,
                movimentacoes: 0,
              })),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      postMovimentacaoEstoqueRecebimento(
        movimentacaoEstoque,
        movimentacaoEstoqueInfo,
        produtos,
        selectedTp,
        style,
      ) {
        EstoqueHttp.postMovimentacaoEstoqueRecebimento(
          { movimentacaoEstoque, movimentacaoEstoqueInfo, produtos, style },
          selectedTp,
        )
          .then(res =>
            setState(prevState => ({
              ...prevState,
              pallets:
                style === 'Manual'
                  ? []
                  : res.map(p => ({ ...p, selected: false, alocated: false })),
              produtos:
                style === 'Manual'
                  ? res.map(p => ({
                      ...p,
                      alocated: false,
                      validade: '__/__/____',
                      lote: '',
                      qte_alocar: p.qte_total,
                    }))
                  : [],
              loadingMessage: LOAD_MESSAGE.POSICOES,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      //Events
      async onInit(selectedTp) {
        if (!selectedTp) {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        } else {
          EstoqueHttp.getOperacoesEstoque(selectedTp)
            .then(res => {
              setState(prevState => ({
                ...prevState,
                operacoes: res.operacoes_entrada_saida.filter(
                  op => !op.belongsToTransfer && op.grupo_de_operacao === 'Avulso',
                ),
              }))
              EstoqueHttp.getEstoques(selectedTp)
                .then(res =>
                  setState(prevState => ({
                    ...prevState,
                    estoques: res,
                    loadingMessage: LOAD_MESSAGE.NONE,
                  })),
                )
                .catch(err =>
                  setState(prevState => ({
                    ...prevState,
                    loadingMessage: LOAD_MESSAGE.NONE,
                    errorMessage: errorHandler(err),
                  })),
                )
            })
            .catch(err =>
              setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })),
            )
        }
      },

      onCloseModalRelatorio() {
        setState(prevState => ({ ...prevState, showModalRelatorio: false }))
      },

      showModalRelatorio() {
        setState(prevState => ({ ...prevState, showModalRelatorio: true }))
      },

      onChange(name, value) {
        setState(prevState => {
          let needToReset = false
          if (name === 'selectedOperacao') {
            needToReset =
              prevState.selectedOperacao && prevState.selectedOperacao.type !== value.type
          }
          prevState[name] = value
          switch (name) {
            case 'selectedOperacao':
              if (needToReset) {
                prevState.posicoes = []
                prevState.produtos = []
                prevState.selectedEstoque = null
                prevState.posicoesSaida = []
                prevState.selectedEmpresa = null
                prevState.selectedProduto = null
                prevState.selectedProdutoSaida = null
              }
              break
            case 'selectedEstoque':
              prevState.loadingMessage = LOAD_MESSAGE.POSICOES
              break
            case 'selectedEmpresa':
              prevState.selectedProduto = null
              prevState.selectedPosicoes = []
              prevState.posicoes = prevState.originalPosicoes
              prevState.loadingMessage = LOAD_MESSAGE.PRODUTOS
              break
            case 'selectedProdutoSaida':
              prevState.selectedPosicoes = []
              if (value) prevState.loadingMessage = LOAD_MESSAGE.POSICOES_SAIDA
              break
            case 'selectedProduto':
              prevState.posicoes.forEach(p => (p.alocated = false))
              if (value) {
                prevState.posicoes.forEach(p => {
                  const produtoAdded = p.produtos.filter(produto => produto.id === value.id)
                  if (produtoAdded.length) p.alocated = true
                })
              }
              break
            default:
              break
          }

          return { ...prevState }
        })
      },

      onChangeProduto(produtoId, value, name) {
        setState(prevState => {
          const index = prevState.produtos.findIndex(p => p.id === produtoId)
          if (index !== -1) {
            prevState.produtos[index][name] = value
          }
          return { ...prevState }
        })
      },

      onChangePosicao(posicaoId, value, name) {
        setState(prevState => {
          const index = prevState.posicoesSaida.findIndex(p => p.id === posicaoId)
          if (index !== -1) {
            prevState.posicoesSaida[index][name] = value
          }
          return { ...prevState }
        })
      },

      onBtnPesquisarClick(dataInicial, dataFinal) {
        setState(prevState => ({
          ...prevState,
          periodo: { dataInicial, dataFinal },
          loadingMessage: LOAD_MESSAGE.PICKINGS,
        }))
      },

      onSearchPosicoesChange(value) {
        setState(prevState => {
          prevState.searchPosicao = value

          if (!prevState.originalPosicoes.length) return { ...prevState }

          if (!value.length) prevState.posicoes = prevState.originalPosicoes
          else {
            prevState.posicoes = prevState.originalPosicoes.filter(p =>
              p.endereco.toLowerCase().includes(value.toLowerCase()),
            )
          }

          return { ...prevState }
        })
      },

      onSearchPalletsChange(value) {
        setState(prevState => {
          prevState.searchPallet = value

          if (!prevState.originalPallets.length) return { ...prevState }

          if (!value.length) prevState.pallets = prevState.originalPallets
          else {
            prevState.pallets = prevState.originalPallets.filter(p =>
              p.id.toString().toLowerCase().includes(value.toLowerCase()),
            )
          }

          return { ...prevState }
        })
      },

      onClickPosicao(posicao) {
        setState(prevState => ({ ...prevState, selectedPosicao: posicao }))
      },

      onClickPallets(pallet) {
        setState(prevState => {
          const index = prevState.pallets.findIndex(p => p.id === pallet.id)
          prevState.pallets[index].selected = !prevState.pallets[index].selected

          return { ...prevState }
        })
      },

      onClickAlocar(selectedProduto, selectedPosicoes) {
        if (!selectedProduto) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione um produto para alocar',
          }))
          return
        }

        const validadeHasError = this.validatDataValidade(selectedProduto.validade)
        if (validadeHasError)
          setState(prevState => ({ ...prevState, errorMessage: validadeHasError }))
        else if (!selectedPosicoes.length)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione pelo menos uma posição para alocar',
          }))
        else if (!selectedProduto.qte_alocar)
          setState(prevState => ({ ...prevState, errorMessage: 'Insira um numero maior que 0.' }))
        else if (!Number(selectedProduto.qte_alocar))
          setState(prevState => ({ ...prevState, errorMessage: 'Insira um numero maior que 0.' }))
        else {
          setState(prevState => {
            selectedProduto.validade = selectedProduto.validade.includes('_')
              ? null
              : selectedProduto.validade
            selectedProduto.timestamp = new Date()

            for (const selectedPosicao of selectedPosicoes) {
              const index = prevState.posicoes.findIndex(p => p.id === selectedPosicao.id)

              prevState.posicoes[index].produtos.push({ ...selectedProduto })
              prevState.posicoes[index].caixas_novas += Number(selectedProduto.qte_alocar)
            }

            prevState.produtos.forEach(p => {
              if (p.id === selectedProduto.id) p.movimentacoes += selectedPosicoes.length
              p.validade = '__/__/____'
              p.lote = null
              p.qte_alocar = null
            })

            prevState.selectedPosicoes = []
            prevState.selectedProduto = null
            return { ...prevState }
          })
        }
      },

      validatDataValidade(validade) {
        if (!validade || validade.includes('__')) return null

        const validadeDatas = validade.split('/').map(Number)

        if (validadeDatas[0] < 1 || validadeDatas > 31) return 'Insira um dia valido'
        else if (validadeDatas[1] < 1 || validadeDatas[1] > 12) return 'Insira um mês valido'
        else if (validadeDatas[2] < 2018 || validadeDatas[2] > 2200) return 'Insira um ano valido'
        return null
      },

      onClickRemoverMovimentacao(selectedProduto) {
        setState(prevState => {
          prevState.posicoes.forEach(p => {
            if (p.id === selectedProduto.posicao_id) {
              p.produtos = p.produtos.filter(
                prod => !(prod.timestamp === selectedProduto.timestamp),
              )
              p.caixas_novas -= Number(selectedProduto.quantidade)
            }
          })

          prevState.produtos.forEach(p => {
            if (p.id === selectedProduto.product_id) p.movimentacoes--
          })

          const movimentacoes = []

          prevState.posicoes.forEach(pos => {
            pos.produtos.forEach(prod => {
              if (prod.id === selectedProduto.product_id) {
                movimentacoes.push({
                  product_id: prod.id,
                  posicao_id: pos.id,
                  endereco: pos.endereco,
                  validade: prod.validade,
                  lote: prod.lote,
                  quantidade: prod.qte_alocar,
                  timestamp: prod.timestamp,
                })
              }
            })
          })

          prevState.modal.data = movimentacoes

          return { ...prevState }
        })
      },

      onCloseModal() {
        setState(prevState => ({ ...prevState, modal: { data: null, show: false } }))
      },

      onOpenModal(data) {
        setState(prevState => {
          const movimentacoes = []

          prevState.posicoes.forEach(pos => {
            pos.produtos.forEach(prod => {
              if (prod.id === data.id) {
                movimentacoes.push({
                  product_id: prod.id,
                  posicao_id: pos.id,
                  endereco: pos.endereco,
                  validade: prod.validade,
                  lote: prod.lote,
                  quantidade: prod.qte_alocar,
                  timestamp: prod.timestamp,
                })
              }
            })
          })

          if (!movimentacoes.length)
            prevState.errorMessage = 'Não existem movimentações a serem exibidas'
          else {
            prevState.modal = {
              data: movimentacoes,
              show: true,
            }
          }

          return { ...prevState }
        })
      },

      async onClickExpedir(selectedPosicoes, posicoesSaida, justificativaArg) {
        if (!selectedPosicoes.length)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione pelo menos uma posição para expedir',
          }))
        else if (selectedPosicoes.some(sp => !(Number(sp.qte_remover) > 0)))
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Insira um valor valido para remoção',
          }))
        else if (selectedPosicoes.some(sp => Number(sp.qte_remover) > Number(sp.quantidade)))
          setState(prevState => ({
            ...prevState,
            errorMessage:
              'Algum dos items selecionados possui quantia para remoção maior que a disponível em estoque.',
          }))
        else
          setState(prevState => ({
            ...prevState,
            showDialogExpedir: true,
            justificativa:
              justificativaArg !== undefined ? justificativaArg : prevState.justificativa,
          }))
      },

      async onExpedir(
        selectedPosicoes,
        selectedProduto,
        data,
        hora,
        operacao,
        selectedTp,
        justificativaArg,
      ) {
        if (!operacao) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione uma operação antes de concluir.',
          }))
          return
        }

        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.MOVING }))

        const movimentacaoEstoque = {
          operacao_estoque_id: operacao.id,
          data_movimentacao: `${parseToMysqlFormat(data)} ${hora || '00:00'}:00`,
          tp_id: selectedTp,
          user_id: getUsuarioInfo().id,
        }

        if (!selectedPosicoes.length) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Você precisar selecionar pelo menos um produto para expedir.',
            loadingMessage: LOAD_MESSAGE.NONE,
          }))
          return
        }

        const movimentacoesEstoqueInfo = []

        const posicoesIds = Array.from(new Set(selectedPosicoes.map(p => p.posicao_id)))

        for (const posicaoId of posicoesIds) {
          movimentacoesEstoqueInfo.push({
            posicao_estoque_id: posicaoId,
            type: 'avulso',
          })
        }

        const produtos = selectedPosicoes.map(p => ({
          id: p.posicao_estoque_info_id,
          product_id: p.product_id,
          name: selectedProduto.name,
          qte_alocar: p.qte_remover,
          qte_alocated: p.qte_remover,
          validade: p.validade && p.validade.includes('_') ? null : p.validade,
          lote: p.lote,
          posicao_estoque_info_id: p.posicao_estoque_info_id,
          posicao_estoque_info_item_id: p.posicao_estoque_info_item_id,
          posicao: {
            id: p.posicao_id,
          },
        }))

        await EstoqueHttp.createMovimentacaoAvulsoExpedicao(selectedTp, {
          movimentacaoEstoque: movimentacaoEstoque,
          movimentacaoEstoqueInfo: movimentacoesEstoqueInfo,
          produtos: produtos,
          justificativa: justificativaArg !== undefined ? justificativaArg : state.justificativa,
        })
          .then(() =>
            setState(prevState => ({
              ...prevState,
              posicoesSaida: [],
              selectedPosicoes: [],
              loadingMessage: LOAD_MESSAGE.POSICOES_SAIDA,
              showDialogExpedir: false,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      async onClickConcluir(posicoes, data, hora, operacao, selectedTp, justificativaArg) {
        const posicoesComProdutos = posicoes.filter(p => p.produtos.length)

        if (!operacao) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione uma operação antes de concluir.',
          }))
          return
        }

        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.MOVING }))

        const movimentacaoEstoque = {
          operacao_estoque_id: operacao.id,
          data_movimentacao: `${parseToMysqlFormat(data)} ${hora || '00:00'}:00`,
          tp_id: selectedTp,
          user_id: getUsuarioInfo().id,
        }

        if (!posicoesComProdutos.length) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Você precisar alocar pelo menos um produto para prosseguir.',
            loadingMessage: LOAD_MESSAGE.NONE,
          }))
          return
        }

        const movimentacoesEstoqueInfo = []

        const posicoesIds = Array.from(new Set(posicoesComProdutos.map(p => p.id)))

        for (const posicaoId of posicoesIds) {
          movimentacoesEstoqueInfo.push({
            posicao_estoque_id: posicaoId,
            type: 'avulso',
          })
        }

        posicoesComProdutos.forEach(p => {
          p.produtos.forEach(prod => {
            prod.posicao = { id: p.id }
            prod.validade =
              prod.validade && prod.validade.length && !prod.validade.includes('_')
                ? parseToMysqlFormat(prod.validade)
                : null
            prod.lote = prod.lote && prod.lote.length ? prod.lote : null
          })
        })

        const produtosToAdd = posicoesComProdutos
          .map(p => p.produtos)
          .reduce((prev, curr) => prev.concat(...curr), [])

        await EstoqueHttp.createMovimentacaoAvulsoEntrada(selectedTp, {
          movimentacaoEstoque: movimentacaoEstoque,
          movimentacaoEstoqueInfo: movimentacoesEstoqueInfo,
          produtos: produtosToAdd,
          justificativa: justificativaArg !== undefined ? justificativaArg : state.justificativa,
        })
          .then(() =>
            setState(prevState => ({
              ...prevState,
              selectedProduto: [],
              selectedPosicoes: [],
              produtos: prevState.produtos.map(p => ({
                ...p,
                qte_alocar: 0,
                validade: '',
                lote: '',
                movimentacoes: 0,
              })),
              loadingMessage: LOAD_MESSAGE.POSICOES,
              justificativa: '',
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      onChangeJustificativa(value) {
        setState(prevState => ({ ...prevState, justificativa: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}
